import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions
} from 'devextreme-react/form';
import { LVForm } from "../Basicos/LVForm";
import { function_ABM_ZON_Companias_Leer, function_ABM_ZON_Companias_ModificarLogo } from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Companias";
import { function_base64ToHex } from "../../funciones/Varios";
import LVButtonAccion from "../Basicos/LVButtonAccion";

const ABM_ZON_Companias = (props) => {
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [imagenLogoBase64, setImagenLogoBase64] = useState(null);
  const [imagenLogoPreview, setImagenLogoPreview] = useState(null);

  const handleOnClick_Guardar = async (e) => {
    try {
      /*
            const JSON = await function_ABM_ZON_Companias_Generar_JSON(datos.Descripcion)
      
            if (props.Codigo.Codigo === "--NUEVO--") {
      
              const Creado = await function_ABM_ZON_Companias_Insertar(JSON, false)
      
              alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
            } else {
      
              const Modificado = await function_ABM_ZON_Companias_Modificar(JSON, false)
      
              alert("Se ha modificado el Código: " + datos.CodigoCompania)
            }
      */
      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  const handleOnClick_GuardarImagenLogo = async (e) => {
    try {
      const logoHex = function_base64ToHex(imagenLogoBase64);

      await function_ABM_ZON_Companias_ModificarLogo(props.Codigo.Codigo, logoHex);
      alert("Logo guardado correctamente");
    } catch (error) {
      alert("Error al guardar el logo");
      console.error(error);
    }
  };

  const handleImagenLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagenLogoPreview(reader.result); // Vista previa
        setImagenLogoBase64(reader.result.split(",")[1]); // Guardar solo la parte Base64
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {

    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            Descripcion: ''
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_ZON_Companias_Leer(props.Codigo.Codigo)
          setDatos(datosDocumento.data[0])          

          if (datosDocumento.data[0]?.Logo) {
            let mimeType = "image/jpeg"; // Valor por defecto

            // Detectar el formato a partir del encabezado de la cadena Base64
            if (datosDocumento.data[0].Logo.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (datosDocumento.data[0].Logo.startsWith("iVBOR")) mimeType = "image/png";
            else if (datosDocumento.data[0].Logo.startsWith("R0lGOD")) mimeType = "image/gif";

            const logoUrl = `data:${mimeType};base64,${datosDocumento.data[0].Logo}`;
            setImagenLogoPreview(logoUrl);
          }
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  const validateForm = (e) => {
    e.component.validate();
  };

  return (
    <LVForm
      colCount={1}
      formData={datos}
      onContentReady={validateForm}
    >
      <GroupItem caption="General">
        <SimpleItem dataField="CodigoCompania" >
          <Label text="Código" />
          <RequiredRule message="Indicar el Código es obligatorio." />
        </SimpleItem>
        <SimpleItem dataField="Descripcion">
          <Label text="Descripción" />
          <RequiredRule message="Indicar la Descripción es obligatorio." />
        </SimpleItem>

        <SimpleItem>
          <Label text="Cargar Logo" />
          <input type="file" accept="image/*" onChange={handleImagenLogoChange} />
        </SimpleItem>

        {imagenLogoPreview && (
          <SimpleItem>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", marginTop: "10px" }}>
              <img
                src={imagenLogoPreview}
                alt="Vista Previa"
                style={{
                  maxWidth: "100%",
                  maxHeight: "150px",
                  objectFit: "contain",
                }}
              />
              <LVButtonAccion Texto={"GUARDAR LOGO"} onClick={handleOnClick_GuardarImagenLogo} />
            </div>
          </SimpleItem>
        )}
      </GroupItem>

      <ButtonItem horizontalAlignment="Center">
        <ButtonOptions onClick={handleOnClick_Guardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_ZON_Companias;